import React from 'react';
import { Chip } from '@mui/material';
import { Close } from '@mui/icons-material';
import PropTypes from 'prop-types';

const index = ({ label, handleDelete }) => {
  return (
    <Chip
      label={label}
      size="small"
      onDelete={(event) => {
        event.preventDefault();
        handleDelete();
      }}
      deleteIcon={
        <Close
          fontSize="small"
          onMouseDown={(event) => event.stopPropagation()}
        />
      }
      sx={{
        fontFamily: 'Mulish',
        fontSize: '12px',
        lineHeight: '15px',
        minHeight: 'fit-content',
        color: '#FAFAFA',
        bgcolor: '#054E8B',
        '& .MuiChip-deleteIcon': {
          color: 'inherit',
          bgcolor: 'inherit',
        },
      }}
    />
  );
};
index.propTypes = {
  label: PropTypes.string.isRequired,
  handleDelete: PropTypes.func.isRequired,
};
export default index;
